import Axios from 'axios'

const HomeModule = {
  namespaced: true,
  state: {
    slideItems: [],
    offers: [
      {
        title: 'CASAMIA Nilaveli',
        imgPath: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/home/offer_1.jpg`,
        description: 'Lorem ipsum dolor sit amet',
        link: 'casamia-nilaveli#special-packages'
      },
      {
        title: 'CASAMIA Colombo @ on Three20',
        imgPath: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/home/offer_2.jpg`,
        description: 'Lorem ipsum dolor sit amet',
        link: 'casamia-colombo#special-packages'
      },
      {
        title: 'Turtle Nest Rekawa',
        imgPath: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/home/offer_3.jpg`,
        description: 'Lorem ipsum dolor sit amet',
        link: 'turtle-nest#special-packages'
      }
    ]
  },
  mutations: {
    setSliderImages (state, images) {
      state.slideItems = images
    }
  },
  actions: {
    async fetchSliderImages ({ commit }) {
      try {
        const res = await Axios.get('/home/slider')
        if (res) {
          commit('setSliderImages', res.data)
        }
      } catch (e) {
        commit('setSliderImages', [])
        throw e
      }
    }
  },
  getters: {
    sliderImages: (state) => {
      return state.slideItems
    }
  }
}

export default HomeModule
